import { CheckCircleIcon, SmileyXEyesIcon, TimerIcon, XCircleIcon } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

export default function AttemptAnalysisSummaryTable({ data, subjectMeta }) {
  const [finalData, setFinalData] = useState(null);
  useEffect(() => {
    if (!data) return;
    const processedData = {};
    Object.entries(data).forEach((item) => {
      const [subject, subjectData] = item;
      if (subject === 'subjectData') return;
      subjectData.subject = subjectMeta[subject];
      processedData[subject] = subjectData;
    });
    setFinalData(processedData);
  }, [data]);

  if (!finalData) return null;

  console.log('finalData', finalData);

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 leading-snug text-sm font-medium">Subject</div>
            </td>
            <td className="py-3 px-4 min-w-[135px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 mx-auto leading-snug flex flex-row gap-2 items-center justify-center text-[var(--q3-green-normal)] text-sm font-medium">
                <CheckCircleIcon size={20} /> Perfect
              </div>
            </td>
            <td className="py-3 px-4 min-w-[135px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 mx-auto leading-snug flex flex-row gap-2 items-center justify-center text-[var(--q3-danger-normal)] text-sm font-medium">
                <XCircleIcon size={20} /> Wasted
              </div>
            </td>
            <td className="py-3 px-4 min-w-[135px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 mx-auto leading-snug flex flex-row gap-2 items-center justify-center text-[var(--q3-orange-normal)] text-sm font-medium">
                <TimerIcon size={20} /> Overtime
              </div>
            </td>
            <td className="py-3 px-4 min-w-[135px] text-center align-middle">
              <div className="line-clamp-2 mx-auto leading-snug flex flex-row gap-2 items-center justify-center text-[var(--q3-neutral-light)] text-sm font-medium">
                <SmileyXEyesIcon size={20} /> Confused
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.values(finalData)?.map((item, index) => (
            <tr
              key={index}
              className={`border-b border-[var(--q3-stroke-light)] ${index === Object.keys(data).length - 1 && 'border-b-0'} hover:bg-[var(--q3-surface-dim)]`}
            >
              <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
                <div className="flex flex-row justify-start items-center px-4 gap-4">
                  <img src={item?.subject?.icon} alt={item?.subject?.title} className="w-6 h-6" />
                  <p className="truncate text-base font-semibold text-[var(--q3-neutral-default)]">
                    {item?.subject?.title}
                  </p>
                </div>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-center font-medium">{item?.perfect}</td>
              <td className="border-r border-[var(--q3-stroke-light)] text-center font-medium">{item?.wasted}</td>
              <td className="border-r border-[var(--q3-stroke-light)] text-center font-medium">{item?.overtime}</td>
              <td className="text-center font-medium">{item?.confused}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
